import { useState } from 'react';
import { X, Search, ArrowUpDown, ChevronDown } from 'lucide-react';

const condicionesEntregaList = [
  { codigo: 'CFR', nombre: 'Coste y flete (C & F)' },
  { codigo: 'CIF', nombre: 'Coste, seguro y flete (CAF)' },
  { codigo: 'CIP', nombre: 'Porte y seguro pagados hasta punto de destino convenido' },
  { codigo: 'CPT', nombre: 'Porte pagado hasta punto de destino convenido' },
  { codigo: 'DAP', nombre: 'Entregada en Lugar Convenido' },
  { codigo: 'DAT', nombre: 'Entregada en Terminal' },
  { codigo: 'DDP', nombre: 'Franco despachado en aduana' },
  { codigo: 'DPU', nombre: 'Entregada en Lugar Descargada' },
  { codigo: 'EXW', nombre: 'En la fábrica' },
  { codigo: 'FAS', nombre: 'Franco al costado del buque' },
  { codigo: 'FCA', nombre: 'Franco transportista' },
  { codigo: 'FOB', nombre: 'Franco a bordo' },
  { codigo: 'XXX', nombre: 'Otras condiciones' },
];

export function getCondicionesEntrega() {
  return condicionesEntregaList;
}

export const CondicionesEntregaModal = ({
  condiciones = [],
  isOpen,
  onClose,
  onSelect,
  selectedCondicion,
  title = 'Seleccionar Condición de Entrega',
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('codigo-asc');
  const [isSortOpen, setIsSortOpen] = useState(false);

  const sortOptions = [
    { value: 'codigo-asc', label: 'Código (A-Z)' },
    { value: 'codigo-desc', label: 'Código (Z-A)' },
    { value: 'nombre-asc', label: 'Nombre (A-Z)' },
    { value: 'nombre-desc', label: 'Nombre (Z-A)' },
  ];

  const filteredCondiciones = (condiciones.length ? condiciones : condicionesEntregaList).filter((cond) =>
    cond.codigo.toLowerCase().includes(searchQuery.toLowerCase()) ||
    cond.nombre.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const sortedCondiciones = [...filteredCondiciones].sort((a, b) => {
    switch (sortBy) {
      case 'codigo-asc':
        return a.codigo.localeCompare(b.codigo);
      case 'codigo-desc':
        return b.codigo.localeCompare(a.codigo);
      case 'nombre-asc':
        return a.nombre.localeCompare(b.nombre);
      case 'nombre-desc':
        return b.nombre.localeCompare(a.nombre);
      default:
        return 0;
    }
  });

  const getSortLabel = () => {
    return sortOptions.find((option) => option.value === sortBy)?.label || 'Ordenar por';
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{title}</h2>
          <button
            onClick={() => {
              setSearchQuery('');
              setIsSortOpen(false);
              onClose();
            }}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="flex gap-2 mb-4">
          {/* Search Input */}
          <div className="relative flex items-center gap-2 border-container rounded-full px-3 py-1 flex-1 flex-row">
            <div className="flex-0 pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              className="pr-4 py-2 !border-none no-border search-input"
              style={{ borderWidth: '0px !important', border: '0px !important' }}
              placeholder="Buscar condición..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Custom Sort Dropdown */}
          <div className="relative button-no-hover-effect text-sm">
            <button
              className="flex items-center gap-2 px-2 pr-0 py-2 rounded-full"
              onClick={() => setIsSortOpen(!isSortOpen)}
            >
              <ArrowUpDown className="w-4 h-4" />
              <span>{getSortLabel()}</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${isSortOpen ? 'rotate-180' : ''}`} />
            </button>

            {isSortOpen && (
              <div className="overflow-hidden absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border-container py-1 z-10">
                {sortOptions.map((option) => (
                  <button
                    key={option.value}
                    className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${
                      sortBy === option.value ? 'text-primary' : 'text-gray-700'
                    }`}
                    onClick={() => {
                      setSortBy(option.value);
                      setIsSortOpen(false);
                    }}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="max-h-[60vh] min-h-[30vh] overflow-y-auto">
          {sortedCondiciones.length > 0 ? (
            <div className="space-y-0">
              {sortedCondiciones.map((cond) => (
                <div
                  key={cond.codigo}
                  className={`p-3 px-0 hover:bg-gray-100 cursor-pointer border-bottom-gray ${
                    selectedCondicion && selectedCondicion.codigo === cond.codigo ? 'bg-gray-100 font-bold' : ''
                  }`}
                  onClick={() => {
                    onSelect(cond);
                    setSearchQuery('');
                    setIsSortOpen(false);
                    onClose();
                  }}
                >
                  <div className="flex justify-between items-start gap-2">
                    <div>
                      <p className="font-medium">{cond.codigo}</p>
                      <p className="text-xs text-gray-500">{cond.nombre}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4 text-gray-500">
              No se encontraron condiciones para "{searchQuery}"
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 